import React from 'react';

export const IronGhost = () => {
  return (
    <section className="mrm2-ironghost-container">
      <div className="mrm2-ironghost-section">
        <div className="mrm2-mimic-ironghost-section">
          <div className="mrm2-ironghost-content">
            <div className="mrm2-ironghost-text-section">
              <div className="mrm2-ironghost-titles">
                <h2 className="mrm2-ironghost-subtitle">
                  Control link ground unit
                </h2>
                <h3 className="mrm2-ironghost-title">IRONghost QS</h3>
              </div>

              <p className="mrm2-ironghost-description">
                The key ground-side component for the{' '}
                <span style={{ whiteSpace: 'nowrap' }}>MRM2-10,</span> IRONghost
                QS is a mast-mountable module that connects via a single CAT5
                cable. Its high-power, quad-band design drives{' '}
                <span style={{ whiteSpace: 'nowrap' }}>IRONghost’s</span>{' '}
                EW-resilient C2 link, enabling a 1km operator stand-off.
              </p>
            </div>
            <div className="mrm2-ironghost-text-section">
              <div className="mrm2-ironghost-titles">
                <h2 className="mrm2-ironghost-subtitle">
                  Video link ground unit
                </h2>
                <h3 className="mrm2-ironghost-title">IRONghost RF 5.8</h3>
              </div>

              <p className="mrm2-ironghost-description">
                This module pairs with the IRONghost QS to form the{' '}
                <span style={{ whiteSpace: 'nowrap' }}>MRM2-10’s</span> ground
                station. Its best-in-class{' '}
                <span style={{ whiteSpace: 'nowrap' }}>5.8GHz</span> video
                receiver delivers 40% more range than standard goggle-mounted
                units, while equalized video output ensures operators receive a
                crisp, degradation-free feed via the same CAT5 cable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
